module.exports = __webpack_public_path__ + "img/damage_blaupause.a06ccceb.gif";